import React from "react";
import { Outlet } from "react-router-dom";
import SeoTags from "../util/SeoTags";

function CoursesMenu() {
  return (
    <>
      <SeoTags title={"KriskisStyle | Cursos"} />
      <div className="">
        <div className="container my-5 py-3">
          <Outlet />
        </div>{" "}
      </div>
    </>
  );
}

export default CoursesMenu;
